import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import './shared/server.scss';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store, { sagaMiddleware } from './redux/store';

import './fonts/opensans-bold-webfont.woff';
import './fonts/opensans-light-webfont.woff';
import './fonts/opensans-regular-webfont.woff';
import './fonts/OpenSans-Semibold-webfont.woff';
import { BrowserRouter } from 'react-router-dom';
import { DOMAIN } from './shared';
import rootSaga from './redux/root-sagas';

sagaMiddleware.run(rootSaga);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={'/'+DOMAIN}>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
